import { toast } from 'react-toastify'
import { faClose } from '@fortawesome/free-solid-svg-icons/faClose'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EliteSeatChip from '../Elements/EliteSeatChip'
import { ProfileStatistics } from '../Elements/ProfileStatistics/ProfileStatistics'
import { ProfileQuery } from '@src/pages/Profile/gql/__generated__/ProfileQuery.graphql'
import { useLazyLoadQuery } from 'react-relay'
import { profileQuery } from '@src/pages/Profile/gql/ProfileQuery.gql'
import { formatNumberWithCommas } from '@src/utils/functions'
import {
  ContentWrapper,
  EliteChipWrapper,
  UserInfoRight,
  UserInfoWrapper,
  UserName,
  UserTier,
} from './ProfileModal.styled'
import { Spinner } from '../spinner'
import React from 'react'
import { Avatar } from '@src/components/Avatar/Avatar'

interface Props {
  closeCallback: () => void
  uuid?: string | null
}

const ProfileData = ({ uuid, closeCallback }) => {
  const data = useLazyLoadQuery<ProfileQuery>(profileQuery, { uuid }, { fetchPolicy: 'store-and-network' })

  if (!data) {
    toast.error('Failed to load profile data.')
    return null
  }

  const { name, eliteSeatProgress, hasProfileImage } = data.profile
  const strictWager = (eliteSeatProgress?.wagerAmountUsd ?? 0) / 100

  return (
    <ContentWrapper>
      <FontAwesomeIcon
        className="cursor-pointer bg-separatorGray text-white rounded-full w-22 h-22 p-2 absolute top-15 right-15"
        icon={faClose}
        size="2x"
        onClick={closeCallback}
      />
      <UserInfoWrapper>
        <Avatar name={name} uuid={uuid} hasProfileImage={hasProfileImage} noLink={false} size={83} />
        <UserInfoRight>
          <UserName>{name}</UserName>
          <UserTier>{eliteSeatProgress?.currentLevelName}</UserTier>
          <EliteChipWrapper>
            <EliteSeatChip
              text={`ELITE ${eliteSeatProgress?.currentTier}`}
              tier={eliteSeatProgress?.currentLevelName || ''}
            />
          </EliteChipWrapper>
        </UserInfoRight>
      </UserInfoWrapper>
      <ProfileStatistics profile={data.profile} wager={formatNumberWithCommas(strictWager)} />
    </ContentWrapper>
  )
}

const ProfileModal = ({ closeCallback, uuid }: Props) => {
  if (!uuid) return null

  return (
    <div className="text-white">
      <React.Suspense fallback={<Spinner />}>
        <ProfileData uuid={uuid} closeCallback={closeCallback} />
      </React.Suspense>
    </div>
  )
}

export default ProfileModal
